import { render, staticRenderFns } from "./AllHouse.vue?vue&type=template&id=1f1c6302&scoped=true"
import script from "./AllHouse.vue?vue&type=script&lang=js"
export * from "./AllHouse.vue?vue&type=script&lang=js"
import style0 from "./AllHouse.vue?vue&type=style&index=0&id=1f1c6302&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c6302",
  null
  
)

export default component.exports